"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DialogHeaderContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.DialogHeaderContainer = styled_components_1.default.div `
  font-size: 12px;
  font-weight: bold;

  display: flex;
  justify-content: space-between;

  background-image: linear-gradient(to top, #e0e0e0, white 60%);

  padding: 5px 5px;
  border-bottom: 1px solid #fff;

  > span {
    cursor: pointer;
  }
`;
//# sourceMappingURL=dialog-header-container.js.map